export var KEY_SYSTEM_PLAYREADY_RECOMMENDATION="com.microsoft.playready.recommendation";